export default {
  getXeroChartOfAccount: (state) => state.xeroChartOfAccount,
};
